import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  contentHeader: {
    marginBottom: 20
  },
  headerFlex: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
})

export default useStyles
